import * as React from 'react'
import { GLOBAL_SETTINGS_ASSISTANCE_COLUMN } from '../../state/constants/index'
import { IGlobalSettingsAssistance, IAssistanceObject, IAssistanceCategoryObject } from '../../types/index'
import AssistanceListItem from './AssistanceListItem'

interface IGlobalSettingsMobilityDevicesListProps {
  assistances: IAssistanceObject[]
  categories: IAssistanceCategoryObject[]
  columns: GLOBAL_SETTINGS_ASSISTANCE_COLUMN[]
  getAssistances: () => Promise<any>
  getAssistanceCategories: () => Promise<any>
}

class AssistanceList extends React.Component<IGlobalSettingsMobilityDevicesListProps> {
  constructor(props: any) {
    super(props)
  }

  public componentDidMount() {
    this.props.getAssistances()
    this.props.getAssistanceCategories()
  }

  public render() {
    return (
      <div>
        {Object.values(this.props.assistances).map((it: IAssistanceObject) => (
          <AssistanceListItem
            assistance={it}
            categories={this.props.categories}
            columns={this.props.columns}
            key={`assistance-item-${it.id}`}
          />
        ))}
      </div>
    )
  }
}

export default AssistanceList



// WEBPACK FOOTER //
// ./src/components/global-settings/AssistanceList.tsx